import { useContext } from 'react';
import { AppConfigurations } from '@roc/feature-types';
import { AppConfigurationsContext } from './../context/appConfigurationsContext';

export function useAppConfigurations(): AppConfigurations {
  return useContext(AppConfigurationsContext);
}
